(function () {
    const selects = document.querySelectorAll('[data-custom-select]');

    const closeAll = () =>
        selects.forEach((c) => {
            const trigger = c.querySelector('.custom-select-trigger');
            const dropdown = c.querySelector('.custom-select-dropdown');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.classList.remove('active');
        });

    selects.forEach((container) => {
        const native = container.querySelector('.form-select-native');
        const trigger = container.querySelector('.custom-select-trigger');
        const dropdown = container.querySelector('.custom-select-dropdown');
        const valueDisplay = container.querySelector('.custom-select-value');

        if (!trigger || !dropdown || !native) return;

        let isOpen = false;

        const open = () => {
            closeAll();
            isOpen = true;
            trigger.setAttribute('aria-expanded', 'true');
            dropdown.classList.add('active');

            // geef elke optie focus-mogelijkheid
            dropdown
                .querySelectorAll('.custom-select-option')
                .forEach((opt) => {
                    opt.tabIndex = 0;
                });

            // focus op geselecteerde of eerste optie
            const toFocus =
                dropdown.querySelector('.selected') ||
                dropdown.firstElementChild;
            if (toFocus) {
                requestAnimationFrame(() => toFocus.focus());
            }
        };

        const close = () => {
            if (!isOpen) return;
            isOpen = false;
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('active');
        };

        const toggle = () => (isOpen ? close() : open());

        const select = (opt) => {
            if (!opt) return;
            const value = opt.dataset.value;
            const text = opt.textContent.trim();

            dropdown.querySelectorAll('.custom-select-option').forEach((o) => {
                o.classList.remove('selected');
                o.removeAttribute('aria-selected');
            });
            opt.classList.add('selected');
            opt.setAttribute('aria-selected', 'true');
            valueDisplay.textContent = text;
            native.value = value;
            native.dispatchEvent(new Event('change', { bubbles: true }));
            close();
            trigger.focus();
        };

        // klik op trigger
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
        });

        // toetsen op trigger
        trigger.addEventListener('keydown', (e) => {
            if (['Enter', ' ', 'ArrowDown'].includes(e.key)) {
                e.preventDefault();
                if (!isOpen) open();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                close();
            }
        });

        // klik op optie via delegation
        dropdown.addEventListener('click', (e) => {
            const opt = e.target.closest('.custom-select-option');
            if (opt) {
                e.stopPropagation();
                select(opt);
            }
        });

        // toetsen op optie via delegation
        dropdown.addEventListener('keydown', (e) => {
            const opt = e.target.closest('.custom-select-option');
            if (!opt) return;

            switch (e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    select(opt);
                    break;
                case 'Escape':
                    e.preventDefault();
                    close();
                    trigger.focus();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    opt.nextElementSibling?.focus();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    opt.previousElementSibling?.focus();
                    break;
            }
        });

        // klik buiten of scroll sluit dropdown
        document.addEventListener('click', (e) => {
            if (!container.contains(e.target)) close();
        });

        window.addEventListener(
            'scroll',
            () => {
                if (isOpen) close();
            },
            { passive: true }
        );
    });
})();
